module.exports = __webpack_public_path__ + "static/media/namebk.4e24963c.JPG";